export default "__VITE_ASSET__B8IlWv2C__";